import React, { useRef } from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { BiEventType } from '../../../biLogger';
import { Popper } from '../../../Popover';
import ActionBarButton from '../../_partials/ActionBarButton';
import { ThemeOptions } from '../../../publicSession';
import s from './ArtShopBuyButton.scss';
var ArtShopBuyButton = function (_a) {
    var _b;
    var _c = _a.deviation, deviationId = _c.deviationId, _d = _c.print, print = _d === void 0 ? {} : _d, showFTUE = _a.showFTUE, onDismissFTUE = _a.onDismissFTUE, className = _a.className;
    var rootRef = useRef(null);
    var t = useTranslation().t;
    var purchaseUrl = print.purchaseUrl;
    return (React.createElement("span", { className: c(s['root'], className), ref: rootRef },
        React.createElement(ActionBarButton, { view: "b18", biData: {
                evid: BiEventType.BUY_IN_POPUP_STORE,
                deviationid: deviationId,
            }, href: purchaseUrl, target: "_blank", onMouseLeave: showFTUE ? onDismissFTUE : undefined }, t('actionbar.buyArtStore')),
        showFTUE && (React.createElement(Popper, { width: "311px", 
            /*
              The type for this requires `HTMLElement | undefined`
              but the type for HTMLElement ref objects need to have a type of `HTMLElement | null`.
  
              So we have to use `?? undefined` here to make both work.
            */
            referenceElement: (_b = rootRef.current) !== null && _b !== void 0 ? _b : undefined, contentClassName: c(s['ftue-root'], 'no-theme-skin'), onClickOutside: onDismissFTUE, onMouseLeave: onDismissFTUE, placement: "top", forceTheme: ThemeOptions.DARK },
            React.createElement("img", { 
                // Decorative, so empty alt text
                alt: "", className: s['ftue-image'], src: "https://st.deviantart.net/eclipse/global/svg/il43-buy-art.svg" }),
            React.createElement("div", { className: s['ftue-text-block'] },
                React.createElement("div", { className: s['ftue-heading'] }, t('actionbar.buyArtStore.ftue.heading')),
                React.createElement("div", { className: s['ftue-subtext'] }, t('actionbar.buyArtStore.ftue.subtext')))))));
};
ArtShopBuyButton.displayName = 'ArtShopBuyButton';
export default ArtShopBuyButton;
//# sourceMappingURL=ArtShopBuyButton.js.map